import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../request.js";
import { mapParameters as t } from "../../../tasks/operations/urlUtils.js";

function o(e, t) {
  var o = e.toJSON();
  return o.objectIds && (o.objectIds = o.objectIds.join(",")), o.orderByFields && (o.orderByFields = o.orderByFields.join(",")), !o.outFields || null != t && t.returnCountOnly ? delete o.outFields : -1 !== o.outFields.indexOf("*") ? o.outFields = "*" : o.outFields = o.outFields.join(","), o.outSpatialReference && (o.outSR = o.outSR.wkid || JSON.stringify(o.outSR.toJSON()), delete o.outSpatialReference), o.dynamicDataSource && (o.layer = JSON.stringify({
    source: o.dynamicDataSource
  }), delete o.dynamicDataSource), o;
}

function r(_x, _x2, _x3) {
  return _r.apply(this, arguments);
}

function _r() {
  _r = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t, o) {
    var r, n, a, d, i, _iterator, _step, _s2, _e, _t;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return s(e, t, o);

          case 2:
            r = _context.sent;
            n = r.data;
            a = n.geometryType;
            d = n.spatialReference;
            i = {};
            _iterator = _createForOfIteratorHelper(n.relatedRecordGroups);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _s2 = _step.value;
                _e = {
                  fields: void 0,
                  objectIdFieldName: void 0,
                  geometryType: a,
                  spatialReference: d,
                  hasZ: !!n.hasZ,
                  hasM: !!n.hasM,
                  features: _s2.relatedRecords
                };
                if (null != _s2.objectId) i[_s2.objectId] = _e;else for (_t in _s2) {
                  _s2.hasOwnProperty(_t) && "relatedRecords" !== _t && (i[_s2[_t]] = _e);
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            return _context.abrupt("return", _objectSpread(_objectSpread({}, r), {}, {
              data: i
            }));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _r.apply(this, arguments);
}

function n(_x4, _x5, _x6) {
  return _n.apply(this, arguments);
}

function _n() {
  _n = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t, o) {
    var r, n, a, _iterator2, _step2, _s3;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return s(e, t, o, {
              returnCountOnly: !0
            });

          case 2:
            r = _context2.sent;
            n = r.data;
            a = {};
            _iterator2 = _createForOfIteratorHelper(n.relatedRecordGroups);

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                _s3 = _step2.value;
                null != _s3.objectId && (a[_s3.objectId] = _s3.count);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            return _context2.abrupt("return", _objectSpread(_objectSpread({}, r), {}, {
              data: a
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _n.apply(this, arguments);
}

function s(_x7, _x8) {
  return _s.apply(this, arguments);
}

function _s() {
  _s = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(r, n) {
    var s,
        a,
        d,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            s = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
            a = _args3.length > 3 ? _args3[3] : undefined;
            d = t(_objectSpread(_objectSpread(_objectSpread({}, r.query), {}, {
              f: "json"
            }, a), o(n, a)));
            return _context3.abrupt("return", e(r.path + "/queryRelatedRecords", _objectSpread(_objectSpread({}, s), {}, {
              query: _objectSpread(_objectSpread({}, s.query), d)
            })));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _s.apply(this, arguments);
}

export { r as executeRelationshipQuery, n as executeRelationshipQueryForCount, o as toQueryStringParameters };